import { useEffect } from 'react'
import { useTranslation } from 'libs/i18n'
import { useForm } from 'react-hook-form'
import { InputGroup } from 'shared/molecules'
import { FloormapConfig } from 'features/editor'
import { EditorDimensions } from 'features/editor'
import { Field, fieldButtonClassName } from '../Field'
import { useFloorDimentionsValidationSchema } from './hooks/useFloorDimentionsValidationSchema'

type FloorDimentionsProps = {
	floormapConfig: FloormapConfig
	onSubmit: (data: FloormapConfig) => void
}

export const FloorDimentions = ({ floormapConfig, onSubmit }: FloorDimentionsProps) => {
	const { t } = useTranslation()
	const validationResolver = useFloorDimentionsValidationSchema()

	const {
		handleSubmit,
		register,
		setValue,
		formState: { errors }
	} = useForm({
		resolver: validationResolver,
		mode: 'onChange'
	})

	const submitDimensions = ({ height, width }: any) => {
		const newElement: EditorDimensions = {
			id: crypto.randomUUID(),
			type: 'floorDimentions',
			width,
			height
		}

		onSubmit([...floormapConfig.filter((config) => config.type !== 'floorDimentions'), newElement])
	}

	useEffect(() => {
		const config = floormapConfig?.find((config) => config.type === 'floorDimentions') as
			| EditorDimensions
			| undefined

		if (config?.width) setValue('width', config.width)
		if (config?.height) setValue('height', config.height)
	}, [floormapConfig])

	return (
		<Field label={t('Floor size')} section="floor">
			<form className="space-y-2" onSubmit={handleSubmit(submitDimensions)}>
				<InputGroup
					id="floor-width"
					label={t('Width')}
					placeholder={t('width (px)')}
					{...register('width')}
					error={(errors as any).width}
				/>
				<InputGroup
					id="floor-height"
					label={t('Height')}
					placeholder={t('height (px)')}
					{...register('height')}
					error={(errors as any).height}
				/>
				<button type="submit" className={fieldButtonClassName}>
					{t('Apply')}
				</button>
			</form>
		</Field>
	)
}
